<template>
<div>
    <b-card title="Perfil">
    <b-row>
    <b-col md="4">
      <b-img blank-color="#777" rounded fluid :src="mainPath" class="d-inline-block align-top" alt="BV"></b-img>
      <b-form-file v-model="file" @change="onFileChanged" :state="Boolean(file)" placeholder="Choose a file..."></b-form-file>
    </b-col>
    <b-col>
      <label for="numDoc">No. de Identificacion</label> 
      <b-form-input v-model="NumeroDoc"  type="text"  placeholder="No. de Identificacion" disabled></b-form-input>

      <label for="Nombre">Nombre</label> 
      <b-form-input v-model="Nombre"  type="text"  placeholder="Nombre"></b-form-input>
      
      <label for="Email">Email</label> 
      <b-form-input v-model="Email"  type="text"  placeholder="Email"></b-form-input>
      
      <label for="Direccion">Direccion</label> 
      <b-form-input v-model="Direccion"  type="text"  placeholder="Direccion"></b-form-input>
      
      <label for="Telefono">Telefono</label> 
      <b-form-input v-model="Telefono"  type="text"  placeholder="Telefono"></b-form-input>
      
      <label for="Celular">Celular</label> 
      <b-form-input v-model="Celular"  type="text"  placeholder="Celular"></b-form-input>
      <br>
      <b-link @click="showConfirmPass"> Cambiar contraseña</b-link>


      <div v-if="confirm_pass">
      <label for="password">Password</label> 
      <b-form-input v-model="password"  type="password"  placeholder="Contraseña" autocomplete="off"></b-form-input>
 
        <label for="password">Confirmar Password</label> 
        <b-form-input v-model="c_password"  type="password"  placeholder="Contraseña"></b-form-input>
      </div>

      <div>
        <br>
        <b-button class="pull-right" size="lg" variant="success" @click="sendToServer">Guardar</b-button>
      </div>
    </b-col>
    </b-row>
    
    <b-row>
    <b-col md="5">
    </b-col>
    </b-row>
    </b-card>  
</div>
</template>

<script>
export default {
  name: "profile",
  data: function() {
    return {
      tipoDoc: null,
      NumeroDoc: null,
      Nombre: null,
      Email: null,
      Direccion: null,
      Telefono: null,
      Celular: null,
      perfil: null,
      Turno: null,
      file: null,
      mainPath: "",
      password: "",
      c_password: "",
      confirm_pass: false
    };
  },
  mounted() {
    // invocar los métodos
    this.consultar();
    this.mainPath = localStorage.getItem("urlApi");
    this.mainPath = this.mainPath.replace("/api", "");
  },
  methods: {
    sendToServer() {
      let data = {
        document: this.NumeroDoc,
        name: this.Nombre,
        email: this.Email,
        address: this.Direccion,
        phone: this.Telefono,
        mobile: this.Celular,
        typeDocument: this.tipoDoc,
        profile: this.perfil,
        password: this.password,
        image: this.file
      };

      if (this.password) {
        this.confirm_pass = true;
        if (this.password == this.c_password) {
          this.getStringJson(data).then(response => {
            this.$store
              .dispatch("adminUsersProfileUpdate", response)
              .then(response => {
                alert("Actualizado");
              });
          });
        } else {
          this.$root.showInfoDialog(
            "Mensaje informativo",
            "Password y confirmacion deben coincidir",
            "aceptar"
          );
        }
      } else {
        this.getStringJson(data).then(response => {
          this.$store
            .dispatch("adminUsersProfileUpdate", response)
            .then(response => {
              alert("Actualizado");
            });
        });
      }
    },
    showConfirmPass() {
      this.confirm_pass = !this.confirm_pass;
    },
    getStringJson: function(json) {
      return new Promise((resolve, reject) => {
        let miJson = JSON.stringify(json);
        resolve(miJson);
      });
    },
    consultar() {
      this.$store.dispatch("adminUsersprofiledata").then(Response => {
        this.tipoDoc = this.$store.getters.adminUsers.type_doc;
        this.NumeroDoc = this.$store.getters.adminUsers.num_doc;
        this.Nombre = this.$store.getters.adminUsers.name;
        this.Email = this.$store.getters.adminUsers.email;
        this.Direccion = this.$store.getters.adminUsers.address;
        this.Telefono = this.$store.getters.adminUsers.phone;
        this.Celular = this.$store.getters.adminUsers.cellphone;
        this.perfil = this.$store.getters.adminUsers.id_rol;
        this.Turno = this.$store.getters.adminUsers.turno;
        this.mainPath += this.$store.getters.adminUsers.url;
      });
    },
    transformImage(file) {
      this.getBase64(file).then(response => {
        this.file = response;
        console.log("FILE", this.file);
      });
    },
    onFileChanged(event) {
      this.file = event.target.files[0];
      this.transformImage(this.file);
    },
    getBase64: function(file) {
      return new Promise((resolve, reject) => {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function() {
          resolve(reader.result);
        };
        reader.onerror = function(error) {
          console.log("Error: ", error);
          reject(error);
        };
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/modules/admin/users/profile.vue